module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/college-logos/north-florida-1-7021988d243988ef3a0b85e7028fcc9a.svg";